export default [
  {
    path:'/admin/config/basic',
    name:'Basic',
    component: () => import('@/views/config/basic'),
    meta:{
      title:'设置-设置管理-基本设置',
      keepAlive:false
    }
  },
  {
    path:'/admin/shop/set_config',
    name:'setConfig',
    component:()=>import('@/views/config/set_config'),
    meta:{
      title:'商城-商城设置-基本设置',
      keepAlive:false
    }
  },
  {
    path:'/admin/config/wechatApplet',
    name:'WeChatApplet',
    component:()=>import('@/views/config/WeChatApplet'),
    meta:{
      title:'设置-设置管理-微信小程序',
      keepAlive:false
    }
  },
  {
    path:'/admin/config/wechatOfficial',
    name:'WeChatOfficial',
    component:()=>import('@/views/config/WeChatOfficial'),
    meta:{
      title:'设置-设置管理-微信公众号',
      keepAlive:false
    }
  },
  {
    path:'/admin/config/setUpApp',
    name:'setUpApp',
    component:()=>import('@/views/config/setUpApp'),
    meta:{
      title:'设置-设置管理-APP设置',
      keepAlive:false
    }
  },
  {
    path:'/admin/config/noticeService',
    name:'noticeService',
    component:()=>import('@/views/config/noticeService'),
    meta:{
      title:'设置-设置管理-通知/客服',
      keepAlive:false
    }
  },
  {
    path:'/admin/config/logistics',
    name:'logistics',
    component:()=>import('@/views/config/logistics'),
    meta:{
      title:'设置-设置管理-配送设置',
      keepAlive:false
    }
  },
  {
    path:'/admin/config/payment_settings',
    name:'payment_settings',
    component:()=>import('@/views/config/payment_settings'),
    meta:{
      title:'设置-设置管理-支付设置',
      keepAlive:false
    }
  },
  {
    path:'/admin/config/service/list',
    name:'ServiceList',
    component:()=>import('@/views/config/servicelist'),
    meta:{
      title:'设置-设置管理-客服列表',
      keepAlive:false
    }
  },
  {
    path:'/admin/config/service/msg',
    name:'ServiceMsg',
    component:()=>import('@/views/config/servicemsg'),
    meta:{
      title:'设置-设置管理-客服咨询',
      keepAlive:false
    }
  },
  {
    path: '/admin/config/layout',
    name: 'Layout',
    component: () => import('@/views/config/layout'),
    meta: {
      title: '设置-装修布局'
    }
  },
  {
    path: '/admin/config/homePage',
    name: 'homePage',
    component: () => import('@/views/config/homePage'),
    meta: {
      title: '设置-装修布局-页面设置'
    }
  },
  {
    path: '/admin/config/power/list',
    name: 'PowerList',
    component: () => import('@/views/config/powerList'),
    meta: {
      title: '设置-权限管理-角色管理'
    }
  },
  {
    path: '/admin/config/super/list',
    name: 'SuperList',
    component: () => import('@/views/config/superList'),
    meta: {
      title: '设置-权限管理-账号管理'
    }
  },
  {
    path: '/admin/config/super/logs',
    name: 'SuperLogs',
    component: () => import('@/views/config/superLogs'),
    meta: {
      title: '设置-权限管理-操作日志'
    }
  },
  {
    path: '/admin/shop/frieghtlist',
    name: 'shopFrieghtList',
    component: () => import('@/views/config/frieghtlist'),
    meta: {
      title: '商城设置-运费规则'
    }
  },
  {
    path: '/admin/shop/frieghtedit',
    name: 'shopFrieghtEdit',
    component: () => import('@/views/config/frieghtedit'),
    meta: {
      title: '商城设置-编辑运费规则'
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/config.js